import { render } from "./Discord.vue?vue&type=template&id=3de95619&ts=true"
import script from "./Discord.vue?vue&type=script&lang=ts"
export * from "./Discord.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__